import {Component, OnInit} from '@angular/core';
import {CommonServices} from './services/common.services';
import {MessageService} from './services/message.service';
import {select, Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import { IAppState } from 'app/IAppState';
import { ShowToastService } from 'app/shared/services/showToast.service';
import { I18nService } from 'i18n/i18n.service';

const envSelector = (state: IAppState) => state.environmentState;
@Component({
  selector: 'biz-global-proxy',
  templateUrl: './global-proxy.component.html',
  styleUrls: ['./global-proxy.component.scss']
})
export class GlobalProxyComponent implements OnInit {

  globalProxy: IEnvironmentProxy;
  environment: IProxyObject;
  bizagiEnv;

  constructor(private commonService: CommonServices, private store: Store<IAppState>,
    private _showToastService: ShowToastService, private _i18nService: I18nService
  ) {
  }

  async ngOnInit() {
    const response = await this.commonService.getObject();

    if (response) {
      this.globalProxy = response;
    }
    this.store.pipe(select(envSelector)).pipe(take(1)).subscribe(env => {
      this.bizagiEnv = env;
      this.environment = this.globalProxy.environments[this.bizagiEnv.environment];
    })
  }



  async save() {
    try {
      const response = await this.commonService.updateObject(this.globalProxy);
      if (response) {
        this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
      } else {
        this._showToastService.showToast(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'), 'error');
      }
    } catch (e) {
      this._showToastService.showToast(e.message, 'error');
    }
  }


}
